import React, { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import { chatService } from "../../services";
import { ChatInputBar } from "./ChatInputBar";
import { ChatPanel } from "./ChatPanel";

// phase 1: only show the chatbot on competitive screens
const COMPETITIVE_PATHS = ["/competitor", "/tools"];

const FloatingBar = styled.div`
    position: fixed;
    left: 50%;
    bottom: 24px;
    transform: translateX(-50%);
    z-index: 1000;
    width: min(720px, calc(100vw - 32px));
`;

export const ChatWidget = () => {
    const matchesCompetitive = useRouteMatch(COMPETITIVE_PATHS);
    const token = useSelector((state) => state.session && state.session.user && state.session.user.access);
    const [open, setOpen] = useState(false);
    const [messages, setMessages] = useState([]);
    const [draft, setDraft] = useState("");
    const [pending, setPending] = useState(false);

    if (!matchesCompetitive) return null;

    const sendMessage = () => {
        const question = draft.trim();
        if (!question || pending) return;
        setOpen(true);
        setMessages((prev) => [...prev, { from: "user", text: question }]);
        setDraft("");
        setPending(true);
        chatService.askQuestion(question, token)
            .then(({ answer, sources }) => {
                setMessages((prev) => [...prev, { from: "bot", text: answer, sources }]);
            })
            .catch((error) => {
                setMessages((prev) => [...prev, { from: "bot", text: error.message || "Something went wrong. Please try again.", isError: true }]);
            })
            .finally(() => setPending(false));
    };

    const inputBar = (
        <ChatInputBar value={draft} onChange={setDraft} onSubmit={sendMessage} disabled={pending} autoFocus={open} />
    );

    if (open) {
        return (
            <ChatPanel
                messages={messages}
                pending={pending}
                onClose={() => setOpen(false)}
                onClearChat={() => setMessages([])}
                inputBar={inputBar}
            />
        );
    }

    return (
        <FloatingBar>
            <ChatInputBar
                value={draft}
                onChange={setDraft}
                onSubmit={sendMessage}
                disabled={pending}
                glow
                onOpenHistory={messages.length > 0 ? () => setOpen(true) : undefined}
            />
        </FloatingBar>
    );
};
